/**
 * Copies text and reports whether it REALLY worked. The async Clipboard API needs a secure context and a
 * focused page; when it is refused (or missing) we fall back to the older select-and-copy technique, which
 * still works in in-app browsers and older Android WebViews. Never claim success without one of them succeeding.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      // A page that is not visible/focused can leave this promise pending forever, so never wait on it unbounded.
      await Promise.race([
        navigator.clipboard.writeText(text),
        new Promise<never>((_, reject) => setTimeout(() => reject(new Error('clipboard timeout')), 1500)),
      ]);
      return true;
    }
  } catch {
    /* fall through to the legacy path */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}
